import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import SuratRujukanEdukasiSvc from "@/services/SuratRujukanEdukasi";

@Module({ store, dynamic: true, namespaced: true, name: "surat-rujukan-edukasi" })
class SuratRujukanEdukasiModule extends VuexModule {
  surat: any = null;
  loading = false;

  @Mutation SET_SURAT(val: any) {
    this.surat = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);

    try {
      const dt = await SuratRujukanEdukasiSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_SURAT(data);
    } catch {
      this.SET_SURAT(null);
    }

    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);

    try {
      const dt = await SuratRujukanEdukasiSvc.find(id);
      const { data } = dt.data;
      this.SET_SURAT(data);
    } catch {
      this.SET_SURAT(null);
    }

    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_SURAT(null);
  }
}

export const storeSuratRujukanEdukasi = getModule(SuratRujukanEdukasiModule);
